export default class Interface {
  constructor(client) {
    this.client = client;
  }

  navigateTo(options) {
    const interfaceKey = "interface.navigateTo";

    let params = {
      path: options.path,
      query: options.query,
    };

    return this.client._postMessageWithPromise(interfaceKey, params);
  }

  openSummary(options, newtab) {
    const interfaceKey = "interface.openSummary";

    let params = {
      module: options.module,
      id: options.id,
      newtab: newtab || false,
    };

    return this.client._postMessageWithPromise(interfaceKey, params);
  }

  openListView(options, newtab) {
    const interfaceKey = "interface.openListView";

    let params = {
      module: options.module,
      view: options.view,
      filters: options.filters,
      newtab: newtab || false,
    };

    return this.client._postMessageWithPromise(interfaceKey, params);
  }

  openForm(options, newtab) {
    const interfaceKey = "interface.openForm";

    let params = {
      module: options.module,
      formDetails: options.formDetails,
      newtab: newtab || false,
    };

    return this.client._postMessageWithPromise(interfaceKey, params);
  }

  openQRScanner(options) {
    const interfaceKey = "interface.openQRScanner";

    let params = options || {};

    return this.client._postMessageWithPromise(interfaceKey, params);
  }

  openAnalytics(options, newtab) {
    const interfaceKey = "interface.openAnalytics";

    let params = {
      dataPoints: options.dataPoints,
      dateRange: options.dateRange,
      xAggr: options.xAggr,
      newtab: newtab || false,
    };

    return this.client._postMessageWithPromise(interfaceKey, params);
  }

  showTrend(options) {
    const interfaceKey = "interface.showTrend";

    let params = {
      dataPoints: options.dataPoints,
      dateRange: options.dateRange,
      xAggr: options.xAggr,
    };

    return this.client._postMessageWithPromise(interfaceKey, params);
  }

  showControl(options) {
    const interfaceKey = "interface.showControl";

    let params = {
      resourceId: options.resourceId,
      readingId: options.readingId,
      groupId: options.groupId,
    };

    return this.client._postMessageWithPromise(interfaceKey, params);
  }

  fullscreen() {
    const interfaceKey = "interface.fullscreen";

    let params = {};

    return this.client._postMessageWithPromise(interfaceKey, params);
  }

  trigger(namespace, options) {
    const interfaceKey = "interface.trigger";

    let params = {
      namespace: namespace,
      options: options,
    };

    return this.client._postMessageWithPromise(interfaceKey, params);
  }

  triggerDownload(fileId, fileName) {
    const interfaceKey = "interface.triggerDownload";

    let params = {
      fileId: fileId,
      fileName: fileName,
    };

    return this.client._postMessageWithPromise(interfaceKey, params);
  }

  notify(options) {
    const interfaceKey = "interface.notify";

    let params = {
      options: options,
    };

    return this.client._postMessageWithPromise(interfaceKey, params);
  }

  openURL(options) {
    const interfaceKey = "interface.openURL";

    let params = options || {};

    return this.client._postMessageWithPromise(interfaceKey, params);
  }

  getCurrentPage() {
    const interfaceKey = "interface.getCurrentPage";

    let params = {};

    return this.client._postMessageWithPromise(interfaceKey, params);
  }
}
